export const figureMetaData = [
  {
    id: 'totalAlerts',
    name: 'Total Alerts'
  },
  {
    id: 'l1',
    name: 'L1 Alerts'
  },
  {
    id: 'totalHits',
    name: 'Total Hits'
  },
  {
    id: 'totalFalseHits',
    name: 'Total False Hits'
  },
  {
    id: 'totalTrueHits',
    name: 'Total True Hits'
  },
  {
    id: 'undetermined',
    name: 'Undetermined Hits'
  },
  {
    id: 'hitsYield',
    name: 'Hits Yield'
  }
];

export const filterGroupData = {
  title: 'Business Parameters',
  groupData: [
    {
      title: 'Parameters',
      data: [
        {
          id: 'totalAlerts',
          name: 'Alerts'
        },
        {
          id: 'totalHits',
          name: 'Hits'
        },
        {
          id: 'trueHits',
          name: 'True Hits'
        },
        {
          id: 'falseHits',
          name: 'False Hits'
        },
        {
          id: 'undetermined',
          name: 'Undetermined Hits'
        },
        {
          id: 'level1',
          name: 'L1 Hits'
        }
      ]
    }
  ]
};

export const heatMapColumns = [
  {
    id: 'totalAlerts',
    name: 'Alerts'
  },
  {
    id: 'totalHits',
    name: 'Hits'
  },
  {
    id: 'trueHits',
    name: 'True Hits'
  },
  {
    id: 'falseHits',
    name: 'False Hits'
  },
  {
    id: 'undetermined',
    name: 'Undetermined Hits'
  },
  {
    id: 'level1',
    name: 'L1 Hits'
  },
  {
    id: 'hitYield',
    name: 'Hit Yield'
  }
];

export const subGroupNames = {
  all: 'All',
  sanctions: 'Sanctions',
  adverseMedia: 'Adverse Media',
  pep: 'PEP',
  others: 'Others'
};

export const individual_columns = [
  {
    id: 'name',
    name: 'Name'
  },
  {
    id: 'age',
    name: 'Age (yrs)'
  },
  {
    id: 'gender',
    name: 'Gender'
  },
  {
    id: 'occupation',
    name: 'Occupation'
  },
  {
    id: 'culture',
    name: 'Culture'
  },
  {
    id: 'top_3_wc_matches',
    name: 'Top 3 WC Matches'
  },
  {
    id: 'biz_segment',
    name: 'Business Segment'
  },
  {
    id: 'indicator',
    name: [
      {
        id: 'alerts',
        name: 'Alerts'
      },
      {
        id: 'hits',
        name: 'Hits'
      },
      {
        id: 'true_hits',
        name: 'True Hits'
      },
      {
        id: 'false_hits',
        name: 'False Hits'
      },
      {
        id: 'undetermined',
        name: 'Undetermined Hits'
      },
      {
        id: 'level_1',
        name: 'L1 Hits'
      },
      {
        id: 'hits_yield',
        name: 'Hits Yield'
      }
    ]
  },
  {
    id: 'average_hit_by_alert',
    name: 'Average Hits/Alerts'
  },
  {
    id: 'customer_id',
    name: 'Customer ID'
  }
];

export const corperate_columns = [
  {
    id: 'name',
    name: 'Name'
  },
  {
    id: 'county_of_incorp',
    name: 'Country of Incorp.'
  },
  {
    id: 'year_of_corp',
    name: 'Year of Incorp.'
  },
  {
    id: 'top_3_wc_matches',
    name: 'Top 3 WC Matches'
  },
  {
    id: 'industry_segment',
    name: 'Industry Segment'
  },
  {
    id: 'biz_segment',
    name: 'Business Segment'
  },
  {
    id: 'indicator',
    name: [
      {
        id: 'alerts',
        name: 'Alerts'
      },
      {
        id: 'hits',
        name: 'Hits'
      },
      {
        id: 'true_hits',
        name: 'True Hits'
      },
      {
        id: 'false_hits',
        name: 'False Hits'
      },
      {
        id: 'undetermined',
        name: 'Undetermined Hits'
      },
      {
        id: 'level_1',
        name: 'L1 Hits'
      },
      {
        id: 'hits_yield',
        name: 'Hits Yield'
      }
    ]
  },
  {
    id: 'average_hit_by_alert',
    name: 'Average Hits/Alerts'
  }
];
